import { UTM_PARAM_NAMES } from 'apps/auth/constants/utmParams';

// Ad macros that were never resolved by the ad network (e.g. `{campaign}`)
// must not reach the form, same as when they are stored into cookies.
const isUnresolvedTemplate = (value: string): boolean => /^\{.+}$/.test(value);

export const getUtmParamsFromSearch = (search: URLSearchParams): Map<string, string> => {
    const utmParams = new Map<string, string>();

    UTM_PARAM_NAMES.forEach((name) => {
        const value = search.get(name);
        if (value && !isUnresolvedTemplate(value)) {
            utmParams.set(name, value);
        }
    });

    return utmParams;
};
